import { createFormItem } from "@/component-create/utils/create-form-item";
import { FORM_ITEM } from "@/components/form/enums";

export const searchFormItems = [
  createFormItem('锚位', 'anchorPoint', FORM_ITEM.INPUT),
  createFormItem('操作类型', 'operationType', FORM_ITEM.SELECT, { loader: 'CL_OPERATION_TYPE',allOption: true}),
  createFormItem('操作者', 'nickname', FORM_ITEM.INPUT),
  createFormItem('操作时间起', 'startTime', FORM_ITEM.DATE_PICKER),
  createFormItem('操作时间止', 'endTime', FORM_ITEM.DATE_PICKER),
]
